import { IonIcon, IonItem, IonLabel } from '@ionic/react';
import { AllieBadge } from '@allie/app-ui-lib';
import { FC, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { UtilsContext } from '../../../context';
import { TrackingEvents } from '../../../helpers/tracking-events';
import { AppPage } from '../../../hooks/useRoutes';

const iconPicker = (page: AppPage) => {
  if (page.iosIcon && page.mdIcon) {
    return <IonIcon slot="start" ios={page.iosIcon} md={page.mdIcon} />;
  }

  if (page.customIcon) {
    return page.customIcon;
  }

  return null;
};

export const MenuItem: FC<{
  page: AppPage;
  isLastLevel: boolean;
  level: number;
  expanded: boolean;
}> = ({ page, isLastLevel, level, expanded }) => {
  const { tracker, company } = useContext(UtilsContext);
  const location = useLocation();
  const isSelected = (location.pathname + location.search).includes(page.url);
  const { badgeNumber } = page;

  return (
    <IonItem
      href={page.url}
      mode="md"
      onClick={() => {
        tracker.track(TrackingEvents.MENU.menu_item_accessed, {
          client: company.name,
          menu_item: page.title,
        });
      }}
      // eslint-disable-next-line max-len
      className={`root-menu-item menu-top-line typography item-level-${level} ${isLastLevel ? 'last-level-line' : ''} 
        ${level === 1 && !page.customIcon && !page.iosIcon && !page.mdIcon ? 'non-icon-style' : ''}
        ${isSelected && level === 0 ? 'selected' : ''} ${level === 0 ? 'menu-margin' : ''}
        `}
    >
      <div className="icon-badge-wrapper">
        {iconPicker(page)}
        {!expanded && badgeNumber !== undefined && badgeNumber > 0 && (
          <AllieBadge className='badge' allieColor="error-main">{badgeNumber}</AllieBadge>
        )}
      </div>
      <IonLabel className={`menu-link-group ${isSelected && level !== 0 ? 'selected' : ''}`}>
        {page.title}
      </IonLabel>
      {expanded && <AllieBadge allieColor="error-main">{badgeNumber}</AllieBadge>}
    </IonItem>
  );
};
